const _cache: Record<string, undefined | unknown> = {};

export const cacheHit = (key: string): boolean => {
    return _cache[key] !== undefined;
};

export const useCache = (data?: {
    disabled?: boolean;
}): {fn: (key: string, cb: () => Promise<unknown>) => Promise<unknown>} => {
    const _disabled = data?.disabled || false;
    return {
        fn: async (key, cb) => {
            if (_disabled) {
                return cb();
            }
            if (_cache[key] !== undefined) {
                return _cache[key];
            }
            const promiseResult = await cb();
            _cache[key] = promiseResult;

            return promiseResult;
        },
    };
};
